import I18n from 'I18n';
import { fetchLists, PAGE_COUNT } from 'reporting-data/apis/lists';
export const formatResponse = response => response.results.map(list => ({
  text: list.properties.hs_list_name.value,
  value: list.properties.hs_list_id.value
}));
export const successAlert = (createMethod, listNameOrId) => ({
  titleText: I18n.text(`reporting-ui-components.export.listModal.success.${createMethod}.title`, {
    list: listNameOrId
  }),
  message: I18n.text('reporting-ui-components.export.listModal.success.body'),
  type: 'success'
});
export const errorAlert = createMethod => ({
  titleText: I18n.text(`reporting-ui-components.export.listModal.error.${createMethod}.title`),
  message: I18n.text('reporting-ui-components.export.listModal.error.body'),
  type: 'danger'
});
export const getLoadOptions = objectTypeId => (input, callback, pagination = {
  offset: 0
}) => fetchLists(pagination.offset, objectTypeId, input).then(response => {
  callback(null, {
    options: formatResponse(response),
    pagination: {
      hasMore: response.hasMore,
      length: response.total - response.offset + PAGE_COUNT,
      offset: response.offset
    }
  });
});